export const removeFileIllegalCharacters = (fileName: string | undefined) => {
  return fileName ? fileName.replace(/[/\\?%*:| "<>]/g, '_') : '';
};
